// extracted by mini-css-extract-plugin
export default {"UploadSensitivitiesMenu":"UploadSensitivitiesMenu_UploadSensitivitiesMenu__6swzD","UploadSensitivitiesMenu-banner":"UploadSensitivitiesMenu_UploadSensitivitiesMenu-banner__c2cEy"};